import gql from 'graphql-tag';
import { uploadImage } from './uploadImage';

const createLocationMutation = gql`
  mutation createLocation(
    $name: String!
    $address: String!
    $address2: String
    $city: String!
    $postCode: String!
    $imageKey: String!
    $digiticketsCatId: String
    $description: String!
  ) {
    data: createLocation(
      name: $name
      address: $address
      address2: $address2
      city: $city
      postCode: $postCode
      digiticketsCatId: $digiticketsCatId
      imageKey: $imageKey
      description: $description
    ) {
      id
      name
      address
      address2
      city
      postCode
      digiticketsCatId
      image {
        url
      }
      description
      createdAt
      updatedAt
    }
  }
`;

export const createLocation = async ({ client, params }) => {
  const response = await uploadImage(client, params);

  params.data.imageKey = response;

  const result = await client.mutate({
    mutation: createLocationMutation,
    variables: {
      ...params.data,
    },
  });

  return result.data;
};
